






































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import { patrolManagementServe } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe, PagingUnit],
})
export default class Add extends Vue {
  @Prop(Object) row!: any; // 从父组件接受过来一行的数据
  // 查询分页表单
  scrollbar = true;
  screenWidth: any;
  colNum = 6;

  private detailData: any = {};

  // tagsOfWorkers: any = [
  //   {
  //     name: '李啦啦',
  //   },
  //   {
  //     name: '李啦啦',
  //   },
  // ];
  //
  // private tableData: any = [
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  //   {
  //     type: 'sadsaa',
  //   },
  // ];

  /**
   * @todo 后期需要优化的部分
   * @desc vue 创建数据生命周期,获取父组件传递过来那一行员工的数据。
   * @param1 无
   * @returns 无
   */

  async created() {
    await this.getReceiveData(this.row.id);
  }

  /**
   *【接口】获取任务详情
   * @Params
   * @return
   **/
  async getReceiveData(id: string) {
    try {
      const res: any = await patrolManagementServe.getPatrolTaskReceiveInfoData(id);
      if (res.code === '200') {
        this.detailData = res.data;
        return res.data;
      }
    } catch (e) {
      this.$message.warning('网络异常，请稍后重试。');
    }
  }

  mounted() {
    // this.getData();
    this.hasScrollbar();

    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        if (this.screenWidth < 1300) {
          this.colNum = 8;
          // this.colNumTop = 12;
        } else {
          this.colNum = 6;
          // this.colNumTop = 8;
        }
      })();
    };
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    // this.getPageData();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，清空内容并返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.$emit('on-response');
  }
}
